import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import { User } from "types/user";
import Error from "types/error";
import { generatePath } from "react-router-dom";

export default function useUser(id: string | undefined) {
  const request: Request = {
    url: id ? generatePath(ENDPOINTS.users.one, { id }) : "",
    config: {
      method: "GET",
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.users.one, id],
    queryFn: () => client(request),
    enabled: !!id,
  };

  const { data, ...rest } = useQuery<Response<User>, Error>(requestConfig);

  return { data, ...rest };
}
